function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.95428 0.250116C7.92033 0.174729 7.86937 0.111589 7.80691 0.0675107C7.74445 0.0234322 7.67285 8.87956e-05 7.59985 0H0.399182C0.326312 0.0003511 0.254903 0.0238668 0.192635 0.068018C0.130366 0.112169 0.0795931 0.175286 0.0457763 0.25058C0.0119596 0.325873 -0.0036216 0.410496 0.000708385 0.495347C0.00503837 0.580198 0.0291157 0.662067 0.0703511 0.73215L3.67069 6.7984C3.70738 6.86057 3.75649 6.91141 3.81377 6.94653C3.87106 6.98165 3.9348 7 3.99952 7C4.06423 7 4.12797 6.98165 4.18526 6.94653C4.24254 6.91141 4.29165 6.86057 4.32835 6.7984L7.92868 0.73215C7.97032 0.662211 7.99472 0.580294 7.99924 0.495307C8.00375 0.41032 7.9882 0.325515 7.95428 0.250116ZM3.99952 5.71301L1.16245 0.933269H6.83658L3.99952 5.71301Z",
  fill: "black",
  fillOpacity: 0.8
});

function SvgTriangleOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 7,
    viewBox: "0 0 8 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleOutline);
export default __webpack_public_path__ + "static/media/triangle-outline.0d47d414.svg";
export { ForwardRef as ReactComponent };